import React, { PureComponent } from 'react';

import PackageVariantsContext from './packageVariantsContext';

class ServicePackageProvider extends PureComponent {
  /* eslint-disable react/sort-comp, react/no-unused-state */
  selectVariants = (selectedVariants) => {
    this.setState({
      selectedVariants,
    });
  };

  castCartError = (cartErrors) => {
    this.setState({
      cartErrors,
    });
  };

  state = { // TODO : THE STATE MUST BE DEFINED HERE FOR IT TO RECOGNIZE THE TWO FUNCTIONS
    selectedVariants: [],
    cartErrors: null,
    selectVariants: this.selectVariants,
    castCartError: this.castCartError,
  }
  /* eslint-enable react/sort-comp, react/no-unused-state */

  // eslint-disable-next-line react/prop-types
  render = () => <PackageVariantsContext.Provider value={this.state}>{this.props.children}</PackageVariantsContext.Provider>;
}

export default ServicePackageProvider;
